// External libraries
import styled from 'styled-components';

// Zocdoc libraries
import { blueLink, navy, white } from '@zocdoc/branding/colors';
import { Button } from '@zocdoc-frontend-common/components-button';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { Link } from '@zocdoc-frontend-common/components-link';

// This package
import { SignInForm } from '../../index';
import { StyledLoginButton as LoginButton } from '../../SignInFormView';

export const SocialLoginButtonWrapper = styled.div`
    margin-bottom: 8px;

    ${breakpoint.small} {
        margin-bottom: 12px;
    }
`;

export const SignupButton = styled(Button)`
    height: 48px;
`;

export const StandardLoginWrapper = styled.div`
    margin-top: 24px;
`;

export const StandardLoginDividerText = styled.p`
    color: ${navy};
    font: 16px/16px ${FontFamily.SharpSansSemibold};
    margin-bottom: 16px;
    text-align: center;
`;

export const StandardLoginTitle = styled.p`
    color: ${navy};
    font: 18px/24px ${FontFamily.SharpSansBold};
    margin-bottom: 18px;
    text-align: center;
`;

export const StyledSignInForm = styled(SignInForm)`
    margin-bottom: 18px;

    ${LoginButton} {
        background-color: ${props =>
            !props.isPatientMode ? navy : 'transparent'};
        color: ${props => (!props.isPatientMode ? white : navy)};

        &:hover {
            background-color: ${props =>
                !props.isPatientMode ? 'transparent' : navy};
            color: ${props => (!props.isPatientMode ? navy : white)};
        }
    }
`;

export const ToggleWrapper = styled.div`
    clear: both;
`;

export const Toggle = styled(Link)`
    color: ${blueLink};
    font: 15px/20px ${FontFamily.SharpSansSemibold};
    border-bottom: 0;
`;
